import type { ReactElement } from 'react';
import { BottomNav, Sidebar, TopBar } from './components/Layout';
import { EngineBanner } from './components/Sync';
import { Empty, PageHead, Toaster } from './components/ui';
import { DRILL_META } from './drills/meta';
import { Dashboard } from './pages/Dashboard';
import { DecisionDetail } from './pages/DecisionDetail';
import { DecisionNew } from './pages/DecisionNew';
import { Decisions } from './pages/Decisions';
import { Goals } from './pages/Goals';
import { Guide } from './pages/Guide';
import { KnowledgeDetail } from './pages/KnowledgeDetail';
import { KnowledgeEdit } from './pages/KnowledgeEdit';
import { KnowledgeList } from './pages/KnowledgeList';
import { Review } from './pages/Review';
import { SettingsPage } from './pages/Settings';
import { Stats } from './pages/Stats';
import { Train } from './pages/Train';
import { useRoute } from './router';
import type { DrillKey } from './types';

function page(path: string, query: URLSearchParams): ReactElement {
  if (path === '/') return <Dashboard />;
  if (path === '/train') return <Train key="plan" />;
  if (path === '/guide/memory') return <Guide />;
  if (path === '/review') return <Review />;
  if (path === '/knowledge') return <KnowledgeList key={query.get('domain') ?? ''} initialDomain={query.get('domain') ?? ''} />;
  if (path === '/knowledge/new') return <KnowledgeEdit key="new" />;
  if (path === '/decisions') return <Decisions key={query.get('tab') ?? ''} initialTab={query.get('tab') ?? 'open'} />;
  if (path === '/decisions/new') return <DecisionNew />;
  if (path === '/stats') return <Stats />;
  if (path === '/goals') return <Goals />;
  if (path === '/settings') return <SettingsPage />;
  let m = path.match(/^\/train\/([a-z]+)$/);
  if (m && m[1] in DRILL_META) return <Train key={m[1]} only={m[1] as DrillKey} />;
  m = path.match(/^\/knowledge\/(\d+)$/);
  if (m) return <KnowledgeDetail key={m[1]} id={Number(m[1])} />;
  m = path.match(/^\/knowledge\/(\d+)\/edit$/);
  if (m) return <KnowledgeEdit key={`edit-${m[1]}`} id={Number(m[1])} />;
  m = path.match(/^\/decisions\/(\d+)$/);
  if (m) return <DecisionDetail key={m[1]} id={Number(m[1])} />;
  return (
    <>
      <PageHead title="없는 화면" />
      <Empty>
        주소가 잘못되었습니다. <a href="#/">홈으로</a>
      </Empty>
    </>
  );
}

export function App() {
  const { path, query } = useRoute();
  return (
    <div className="app">
      <Sidebar path={path} />
      <div className="content">
        <TopBar path={path} />
        <EngineBanner />
        <main className="main">{page(path, query)}</main>
      </div>
      <BottomNav path={path} />
      <Toaster />
    </div>
  );
}
